import React, { useCallback, useContext } from "react";
import { Tag, Icon, Tooltip } from "antd";
import styled, { ThemeContext } from "styled-components";

import { Container, Title } from "./FilterComponents";

const QuestionIcon = styled(Icon)`
  margin-left: 8px;

  svg {
    color: ${({ theme }) => theme["@primary"]};
  }
`;

const TagButton = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  border-radius: 4px;
  margin-bottom: 5px;
  margin-right: 5px;
  outline: none;
  padding: 0;

  .ant-tag:focus,
  .ant-tag:hover {
    filter: brightness(95%);
  }

  .ant-tag {
    cursor: pointer;
    margin: 0;
  }
`;

function TagFilterItem({ active, onClick, tag, ...props }) {
  const theme = useContext(ThemeContext);
  const handleClick = useCallback(() => onClick(tag), [onClick, tag]);
  return (
    <TagButton {...props} onClick={handleClick}>
      <Tag color={active ? theme["@primary"] : undefined}>{tag}</Tag>
    </TagButton>
  );
}

export default function TagsFilter({
  loading,
  onChange,
  tags,
  title,
  tooltip,
  type,
  value
}) {
  const handleToggleTag = useCallback(
    tag => {
      onChange(tag === value ? "" : tag);
    },
    [value, onChange]
  );

  return (
    <details data-test={`filter-${type}`} open={value && value !== ""}>
      <Title>
        <h4>
          <span>{title}</span>
          {tooltip && (
            <Tooltip title={tooltip}>
              <QuestionIcon type="question-circle" />
            </Tooltip>
          )}
        </h4>
      </Title>
      <Container data-test={`${type}-tags-filter`}>
        <div>
          {tags.map(tag => (
            <TagFilterItem
              key={tag}
              active={tag === value}
              data-test={`${type}-tag-${tag}`}
              disabled={loading}
              onClick={handleToggleTag}
              tag={tag}
            />
          ))}
        </div>
      </Container>
    </details>
  );
}
